// extracted by mini-css-extract-plugin
export default {"zooms":"zooms_zooms__oMHeq","zoomIn":"zooms_zoomIn__GLBdd","zoomOut":"zooms_zoomOut__rK+fa"};